import { makeRequestAction } from './index';

export const fetchConfAgreement = makeRequestAction('FETCH_CONF_AGREEMENT', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
